import {Model} from '@vuex-orm/core';
import Event from './eventModel';

export default class Seminar extends Model {

    static entity = 'seminar';
    static primaryKey = 'id_seminar';

    static fields() {
        return {
            id_seminar: this.attr(null),
            title: this.attr(null),
            description: this.attr(null),
            mandatory: this.attr(null),
            active: this.attr(null),
            id_event_series: this.number(null),
            user_status: this.attr(null),
            register_start: this.attr(null),
            register_end: this.attr(null),
            invited_at: this.attr(null),
            events: this.hasMany(Event, 'parent_seminar', 'id_seminar'),
            seminar_year_group: this.attr(null),
            _entityAuth: this.attr({}),
        };
    }
}